import React from 'react';

import ProgramShowingListItemSkeleton from './ProgramShowingListItemSkeleton';

type ProgramShowingListSkeletonProps = {
    items?: number;
    selectedDate?: string | 'all';
};

export default function ProgramShowingListSkeleton(props: ProgramShowingListSkeletonProps): React.JSX.Element {
    return (
        <div className="flex flex-col">
            {[...Array(Math.max(0, props.items ?? 3))].map((_, index) => (
                <ProgramShowingListItemSkeleton
                    key={`ProgramListItemSkeleton${index}`}
                    selectedDate={props.selectedDate}
                />
            ))}
        </div>
    );
}
